export default __webpack_public_path__ + "static/media/IMG_2707.3d83fe8c.jpg";